/**
 * The freshness notice a document card shows: the same sentence its Word
 * export prints at the top (functions/src/freshness/documentFreshness.ts),
 * fetched once per card through getDocumentFreshnessV2.
 */

/** Card id on the page -> freshness registry key. */
export const FRESHNESS_KEY_BY_CARD: Record<string, string> = {
  urs: 'urs',
  frs: 'frs',
  sds: 'sds',
  ads: 'ads',
  atds: 'atds',
  sacs: 'sacs',
  iis: 'iis',
  test_plan: 'testPlan',
  uat: 'uatProtocol',
  test_procedure: 'testProcedure',
  test_list: 'testList',
  dataManagementPlan: 'dmp',
  edts: 'edts',
  medicalCodingSpec: 'medicalCodingSpec',
  drcp: 'drcp',
  saerp: 'saerp',
  dblc: 'dblc',
};

export type FreshnessNotices = Record<string, string | null | undefined>;

/** The card's sentence, or null. The page drops the [SPONSOR REVIEW: ...] brackets the file uses. */
export function freshnessNoticeFor(cardId: string, notices: FreshnessNotices): string | null {
  const key = FRESHNESS_KEY_BY_CARD[cardId];
  const text = key ? notices[key] : null;
  if (!text) return null;
  return text.replace(/^\[SPONSOR REVIEW:\s*/, '').replace(/\]$/, '');
}

/** Changes whenever any listed document's generation time changes, so the notices are fetched again. */
export function freshnessRefreshKey(stamps: Record<string, number | null | undefined>): string {
  return Object.keys(stamps)
    .sort()
    .map((k) => `${k}:${stamps[k] ?? ''}`)
    .join('|');
}
